export const wellness_zen = [
  { char: '🧘', name: 'Yoga', nameZh: '冥想/瑜珈', keywords: ['zen', 'meditate', 'peace'], hot: true },
  { char: '🕯️', name: 'Candle', nameZh: '療癒香氛', keywords: ['smell', 'relax', 'light'] },
  { char: '🔮', name: 'Crystal Ball', nameZh: '能量水晶', keywords: ['energy', 'magic', 'luck'], hot: true },
  { char: '🧿', name: 'Nazar', nameZh: '守護之眼', keywords: ['protect', 'blue', 'lucky'] },
  { char: '🪷', name: 'Lotus', nameZh: '純淨蓮花', keywords: ['pure', 'flower', 'zen'], hot: true },
  { char: '🍃', name: 'Leaves', nameZh: '深呼吸', keywords: ['nature', 'air', 'fresh'] },
  { char: '🫧', name: 'Bubbles', nameZh: '放空時間', keywords: ['dream', 'clean', 'relax'] },
  { char: '🍵', name: 'Matcha', nameZh: '靜心茶道', keywords: ['tea', 'japan', 'slow'] },
  { char: '🛀', name: 'Bath', nameZh: '沈浸泡澡', keywords: ['spa', 'relax', 'water'] },
  { char: '🌙', name: 'Crescent Moon', nameZh: '睡前儀式', keywords: ['sleep', 'night', 'dream'] },
  { char: '☁️', name: 'Cloud', nameZh: '雲端漫步', keywords: ['dream', 'high', 'soft'] },
  { char: '💆', name: 'Massage', nameZh: '頭部放鬆', keywords: ['spa', 'care', 'relax'] },
];